module.exports = __webpack_public_path__ + "static/media/Away We Go Cover Art.86dd41f1.jpg";